// extracted by mini-css-extract-plugin
export var root = "loader-module--root--Xm+XJ";